(function(){
  var data=document.getElementById('pdata');
  if(!data) return;
  var variants=JSON.parse(data.textContent);
  var form=document.getElementById('pform'); if(!form) return;
  function opts(){var a=[];form.querySelectorAll('.pdp__opt').forEach(function(o){var r=o.querySelector('input:checked');a.push(r?r.value:null)});return a}
  function fmt(c){return (c/100).toLocaleString('de-DE',{style:'currency',currency:'EUR'})}
  function sized(u,w){if(!u)return u;return u+(u.indexOf('?')>-1?'&':'?')+'width='+w}
  function update(){
    var o=opts();
    var v=variants.find(function(x){return x.options.every(function(val,i){return val===o[i]})});
    if(!v)return;
    var idEl=document.getElementById('pvid'); if(idEl)idEl.value=v.id;
    var pr=document.getElementById('pdp-price');
    if(pr){ // Streichpreis mitfuehren — sonst loescht dieser Aufruf ihn bei jedem Variantenwechsel
      var h=fmt(v.price);
      if(v.compare_at_price&&v.compare_at_price>v.price){
        var rab=Math.round((v.compare_at_price-v.price)*100/v.compare_at_price);
        h+=' <s>'+fmt(v.compare_at_price)+'</s> <span class="spar">\u2212'+rab+' %</span>';
      }
      pr.innerHTML=h;
    }
    var btn=form.querySelector('button[type=submit]'); if(btn){btn.disabled=!v.available;btn.textContent=v.available?'In den Warenkorb':'Ausverkauft'}
    // Bild auf die gewählte Variante (Farbe) umschalten
    var main=document.getElementById('pdp-main');
    if(main && v.featured_image && v.featured_image.src){
      main.src=sized(v.featured_image.src,1100);
      var bp=v.featured_image.src.split('?')[0];
      document.querySelectorAll('.pdp__thumbs img').forEach(function(t){t.classList.toggle('sel',(t.dataset.big||'').split('?')[0]===bp)});
    }
  }
  form.querySelectorAll('.pdp__pill input').forEach(function(r){
    r.addEventListener('change',function(){
      r.closest('.pdp__opt').querySelectorAll('.pdp__pill').forEach(function(p){p.classList.remove('sel')});
      r.closest('.pdp__pill').classList.add('sel'); update();
    });
  });
  update();
})();

/* Mobilmenue: auf/zu inkl. aria-expanded am Burger (der Screenreader muss den Zustand kennen). */
(function(){
  var menue=document.getElementById('mnav');
  if(!menue) return;
  var knoepfe=document.querySelectorAll('[data-mnav]');
  function setzen(offen){
    menue.classList.toggle('open',offen);
    document.body.classList.toggle('mnav-offen',offen);
    document.querySelectorAll('[data-mnav="auf"]').forEach(function(b){b.setAttribute('aria-expanded',offen?'true':'false')});
  }
  knoepfe.forEach(function(b){
    b.addEventListener('click',function(){ setzen(b.dataset.mnav==='auf'); });
  });
  // Tipp auf die abgedunkelte Flaeche neben der Schublade schliesst. Die Flaeche ist
  // ein ::after des body, der Treffer landet also am body — alles ausserhalb des
  // Menues und der Menueknoepfe zaehlt.
  document.addEventListener('click',function(e){
    if(!menue.classList.contains('open')) return;
    if(menue.contains(e.target)) return;
    if(e.target.closest && e.target.closest('[data-mnav]')) return;
    setzen(false);
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&menue.classList.contains('open')) setzen(false); });
})();

/* Zweitbild der Produktkarte erst beim ersten Hover laden - und nur auf Geraeten mit echtem
   Hover. Auf dem Handy wurde es bisher geladen, obwohl es dort nie zu sehen ist. */
(function(){
  if(!window.matchMedia('(hover:hover)').matches) return;
  document.querySelectorAll('.card').forEach(function(karte){
    var laden=function(){
      var bild=karte.querySelector('.card__img--alt');
      if(bild&&!bild.getAttribute('src')&&bild.dataset.src) bild.setAttribute('src',bild.dataset.src);
      karte.removeEventListener('pointerenter',laden);
    };
    karte.addEventListener('pointerenter',laden,{passive:true});
  });
})();
